
const weightingFactorByPosition = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19]

// https://abr.business.gov.au/Help/AbnFormat
const isValidBusinessNumber = australianBusinessNumber => {
  let totalDigitWeightSum = 0;
  australianBusinessNumber.split('').forEach((digit, index) => {
    const weightedDigit = index === 0 ? digit - 1 : digit;
    totalDigitWeightSum += weightedDigit * weightingFactorByPosition[index]
  })
  return totalDigitWeightSum % 89 == 0
}

export default isValidBusinessNumber
